import cn from 'clsx';

import {knobOffset, TrackKnob, useProgressReveal} from '@/components/ProgressTrack';
import {CALIBRATION_TRACK_GRADIENT} from '@/consts/gradients';

const KNOB_WIDTH = 44;

interface CalibrationTrackerProps {
    count: number;
    total: number;
    className?: string;
}

const markerRatio = (index: number, total: number) => (total > 1 ? index / (total - 1) : 0);

const CalibrationTracker = ({count, total, className}: CalibrationTrackerProps) => {
    const knobIndex = Math.min(Math.max(count - 1, 0), Math.max(total - 1, 0));
    const revealedRatio = useProgressReveal(markerRatio(knobIndex, total));

    if (total <= 0) return null;

    return (
        <div
            role='progressbar'
            aria-valuenow={count}
            aria-valuemin={0}
            aria-valuemax={total}
            className={cn('relative h-11 w-full', className)}
        >
            <div
                className='absolute inset-x-0 top-1/2 h-8 -translate-y-1/2 rounded-full'
                style={{backgroundImage: CALIBRATION_TRACK_GRADIENT}}
            />
            {Array.from({length: total}, (_, index) => (
                <span
                    key={index}
                    className='absolute top-1/2 size-2 -translate-x-1/2 -translate-y-1/2 rounded-full bg-orion-2'
                    style={{left: knobOffset(markerRatio(index, total), KNOB_WIDTH)}}
                />
            ))}
            <TrackKnob offset={knobOffset(revealedRatio, KNOB_WIDTH)} width={KNOB_WIDTH} className='border-tertiary'>
                {count}
            </TrackKnob>
        </div>
    );
};

export default CalibrationTracker;
